import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useExpenseCategory, ExpenseCategory } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<ExpenseCategory>
      useData={useExpenseCategory}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

